/** MFA session window: 30 minutes from last totp amr entry. */
export const MFA_SESSION_MAX_AGE_SECONDS = 1800;

/** Shown on pay-by-bank settings and after redirect to profile MFA setup. */
export const MFA_PAY_BY_BANK_REQUIRED =
  "Pay by bank changes require two-factor authentication. Set up an authenticator app to continue.";

/** Link label inside {@link MFA_PAY_BY_BANK_REQUIRED} on gated pay-by-bank screens. */
export const MFA_PAY_BY_BANK_SETUP_LINK = "Set up an authenticator app";

/** Shown when TOTP is enrolled but the session is not elevated. */
export const MFA_PAY_BY_BANK_SESSION_REQUIRED =
  "Confirm with your authenticator app before changing pay by bank settings.";

/** CTA label for elevating an existing MFA enrollment. */
export const MFA_PAY_BY_BANK_SESSION_LINK = "Confirm with authenticator";

export class MfaEnrollmentRequiredError extends Error {
  override name = "MfaEnrollmentRequiredError";
  constructor(message = "Set up two-factor authentication to continue") {
    super(message);
  }
}

export class MfaChallengeCancelledError extends Error {
  override name = "MfaChallengeCancelledError";
  constructor(message = "Two-factor authentication cancelled") {
    super(message);
  }
}

export function isMfaSessionAbortError(error: unknown): boolean {
  return error instanceof MfaEnrollmentRequiredError || error instanceof MfaChallengeCancelledError;
}

/** In-app path only (no open redirects). */
export function isSafeInAppReturnPath(path: string | null | undefined): path is string {
  if (!path || typeof path !== "string") return false;
  if (!path.startsWith("/") || path.startsWith("//")) return false;
  if (path.includes("://")) return false;
  return true;
}

export function buildMfaSetupPath(returnPath?: string): string {
  const params = new URLSearchParams({ setup_mfa: "1" });
  if (returnPath && isSafeInAppReturnPath(returnPath)) {
    params.set("return", returnPath);
  }
  return `/settings/profile?${params.toString()}`;
}
